/**
 * connected-handlers-menu-item.js
 */

import React from 'react';
import { useHistory } from 'react-router-dom';
import { UserContext } from 'contexts/user/user-context';
import GroupCardMobile from '../group-card-mobile';
import { ConnectedHandlersContext } from './connected-handlers-context';
import { connectionsRoute } from './connected-handlers';


export default function ConnectedHandlersMenuItem(props) {
  const { user } = React.useContext(UserContext);
  const { handlers } = React.useContext(ConnectedHandlersContext);
  const history = useHistory();
  
  return (
    <GroupCardMobile
      iconType='group-handlers'
      title='Connected Handlers'
      count={handlers.length}
      route={connectionsRoute(history)}
      description={<>
        {user.role.isHandler && `You're automatically connected to handlers who share the same supervisor, trainer or training group. Tap here to view the handlers from all of these groups.`}
        {user.role.isTrainer && `You're automatically connected to the training groups of handlers that you directly train. Tap here to view the handlers in these training groups.`}
      </>}
    />
  );
}